import { combineReducers } from 'redux'
import userContextReducer from './userContextReducer'
import layoutReducer from './layoutReducer'
import navbarReducer from './navbarReducer'
import chatbotReducer from './chatbotReducer'
import userAccessReducer from './userAccessReducer'
import { documentOwnerReducer } from './documentOwnerSlice'
import { documentTypeReducer } from './documentTypeSlice'
import { searchResultReducer } from './searchSlice'
import { userAdminReducer } from './userAccessSlice'
import { searchParamsReducer } from './searchParamsSlice'

const rootReducer = combineReducers({
  layoutReducer,
  navbarReducer,
  userContextReducer,
  chatbotReducer,
  userAccessReducer,
  documentOwnerReducer,
  documentTypeReducer,
  searchResultReducer,
  userAdminReducer,
  searchParamsReducer
})

export default rootReducer
